import style from "./input_text.module.css";
import React, { useState, useEffect, useImperativeHandle } from "react";
import { className as cx } from "@/helpers/utility/class_name";
// eslint-disable-next-line react/display-name
const InputText = React.forwardRef(
  (
    {
      placeholder = "",
      type = "text", //text | number | tel
      onChange: onChangeHandler = () => {},
      onInput: onInputHandler = () => {},
      onBlur: onBlurHandler = () => {},
      setValue: parentSetValue = (_value) => {},
      title = "",
      errorMsg = "",
      theme = "blue",
      initValue = "",
      helperText = "",
      withRequiredMark = false,
      maxlength="none",
      ...props
    },
    ref
  ) => {
    const [isError, setIsError] = useState();
    const [value, setValue] = useState(initValue);
    const [inputClasses, setInputClasses] = useState([style.input_wrapper])
    useEffect(() => {
      setValue(initValue);
    }, [initValue]);
    useEffect(() => {
      const err = errorMsg != "" ? true : false;
      setIsError(err);
    }, [errorMsg]);
    useEffect(() => {
      parentSetValue(value);
    }, [value]);
    useEffect(() => {
      const getTheme = (themeColor) => {
        switch (themeColor) {
          case "blue":
            return style.theme_blue;
          case "outline":
            return style.theme_outline;
          case "black":
            return style.theme_black;
        }
      }

      setInputClasses([...inputClasses, getTheme(theme)])
    }, [])

    const setInputValue = (value) => {
      let _value = value;
      if (type == "number") {
        _value = Math.abs(value);
      }
      setValue(_value);
    };
    useImperativeHandle(ref, () => {
      return {
        setInputValue: setInputValue,
        value: value,
      };
    });
    const onChangeInputHandler = (e) => {
      const inputValue = e.target.value;
      //TODO: Need Refactor
      if (type == "number") {
        e.target.value = Math.abs(e.target.value);
      }
      setInputValue(inputValue);
      onChangeHandler(e);
    };
    return (
      <div className={cx(inputClasses, isError && style.error)}>
        { title != "" &&
          <label>
            {title}
            {(withRequiredMark && isError) &&
              <span className={style.required_flag}>*</span>
            }
          </label>
        }
        { maxlength == "none" ? (
          <input
            type={type == "numberText" ? "number" : type}
            onInput={onInputHandler}
            placeholder={placeholder}
            onChange={onChangeInputHandler}
            onBlur={onBlurHandler}
            value={value}
            {...props}
          />
        ) : (
          <input
            type={type == "numberText" ? "number" : type}
            onInput={onInputHandler}
            placeholder={placeholder}
            onChange={onChangeInputHandler}
            onBlur={onBlurHandler}
            maxLength={maxlength}
            value={value}
            {...props}
          />
        )}
        { helperText != "" && <span className={style.helper_text}>{helperText}</span> }
        { isError && <p className={style.error_msg}>{errorMsg}</p> }
      </div>
    );
  }
);

export default InputText;
